'use strict';

var processInclude = require('base/util');
var compare = require('./product/compare');

if (compare && typeof compare.initEarly === 'function') {
    compare.initEarly();
}

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('cloudinarysfra/components/search'));
    // processInclude(require('base/product/quickView'));
    processInclude(require('./product/base'));
    processInclude(require('./product/customQuantityselector'));
    if (compare && typeof compare.init === 'function') {
        compare.init();
    } else {
        processInclude(compare);
    }
    processInclude(require('./product/productVariation'));
    processInclude(require('./product/notifyMe'));
    processInclude(require('wishlist_custom/product/wishlistHeart'));
    processInclude(require('./sortfilter/sortingAndFilter'));
    processInclude(require('./experience/components/popularCategoryTile'));
});
